import messages from '../CompanyDetails.messages';
import _ from 'lodash';

// eslint-disable-next-line import/no-default-export
export default (values) => {
    let errors = {};

    if (!values.annualTurnover) {
        errors = _.setWith(
            errors,
            'annualTurnover',
            messages.enterAnnualTurnover
        );
    }

    if (!values?.tradingFrom?.day) {
        errors = _.setWith(
            errors,
            'tradingFrom.day',
            messages.enterTradingFrom
        );
    }

    if (!values?.tradingFrom?.month) {
        errors = _.setWith(
            errors,
            'tradingFrom.month',
            messages.enterTradingFrom
        );
    }

    if (!values?.tradingFrom?.year) {
        errors = _.setWith(
            errors,
            'tradingFrom.year',
            messages.enterTradingFrom
        );
    }

    return errors;
};
